import React, { useEffect } from "react";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";

// import { DesktopMain, MobileMain } from "./Main";
import Main from "./Main";
import Leaderboard from "./Leaderboard";
import Invitation from "./Invitation";
import Hero from "./Hero";
import { useModal } from "../../context/ModalContext";

const Homepage = () => {
  const { openNewPasswordModal } = useModal();
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    //use effect for reset password token redirected to homepage
    const resetToken = searchParams.get("reset-token");
    if (resetToken) {
      try {
        const decoded = JSON.parse(atob(resetToken));
        const email = decoded.email;
        const token = decoded.token;
        if (email && token) {
          const newSearchParams = new URLSearchParams(searchParams);
          newSearchParams.delete("reset-token");
          navigate(
            {
              pathname: location.pathname,
              search: newSearchParams.toString(),
            },
            { replace: true }
          );
          openNewPasswordModal({ email, token });
        }
      } catch (e) {
        console.error("Invalid reset token in URL");
      }
    }
  }, [
    searchParams,
    openNewPasswordModal,
    location.pathname,
    navigate,
  ]);

  useEffect(() => {
    // Handle scroll when navigating from category dropdown
    if (location.state?.scrollTo) {
      const sectionId = `section-${location.state.scrollTo}`;

      const timer = setTimeout(() => {
        const element = document.getElementById(sectionId);
        if (element) {
          element.scrollIntoView({
            behavior: "smooth",
            block: "start",
          });
        } else {
          console.warn(`Element with id "${sectionId}" not found`);
        }
      }, 300); // Increased delay to ensure all components are mounted

      return () => clearTimeout(timer);
    }
  }, [location.state]);

  return (
    <div>
      <Hero />
      <div className="bp:row-8 bp:px-14">
        {/* <DesktopMain />
        <MobileMain /> */}
        <Main />
        <div>
          <div className="hidden bp:sticky bp:top-20 bp:col-12 bp:pt-10">
            <Leaderboard />
            <Invitation />
          </div>
        </div>
      </div>

      {/* Modals now use useModal Context and don't need props */}
      {/* <LoginModal />
      <SignUpModal />
      <ForgotPasswordModal />
      <ResetPasswordResponseModal />
      <NewPasswordModal /> */}
    </div>
  );
};

export default Homepage;
